<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb DB-Heavent">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/ProspectService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active" aria-current="page">
              ประวัติการแก้ไข
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile History -->
      <div
        class="ps-0 pe-0 ps-lg-5 pe-lg-3 col-left-menu d-inline-block d-lg-none"
      >
        <div class="left-menu">
          <ul class="d-flex d-lg-block fw-normal">
            <li class="menu-item mian-menu opened">
              <div class="claim-list active">
                <router-link to="/ProspectService" class="blue-1 font-family text-decoration-none"
                  >ข้อมูลยื่นคำร้อง</router-link
                >
                <div class="caret d-none d-lg-block"></div>
              </div>
            </li>
            <li class="menu-item mian-menu">
              <div class="claim-history">
                <router-link
                  to="/ProspectHistory"
                  class="white font-family text-decoration-none"
                  >ประวัติการแก้ไข</router-link
                >
                <div class="caret d-none d-lg-block"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="container mt-1">
          <div class="mt-1 mb-1 border-bottom" style="height: 300px">
            <HistoryMoblie />
          </div>
        </div>
      </div>
      <!-- Mobile History -->
      <div class="col d-none d-lg-block">
        <div class="title border-bottom font-family blue-1">
          ประวัติการแก้ไข
        </div>
        <div class="border-bottom pb-3 position-relative font-family">
          <div class="mt-4 mt-lg-2">
            <div style="height: 520px">
              <History />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import HistoryMoblie from "@/components/prospectservice/HistoryMoblie.vue";
import Menu from "@/components/prospectservice/Menu.vue";
import History from "@/components/prospectservice/History.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "ProspectHistoryView",
  components: {
    Menu,
    History,
    HistoryMoblie,
    LoadingBs5,
  },
  data() {
    return {
      Loading: true,
    };
  },
  mounted() {
    if(this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }

    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;

        this.Loading = false;
      }
    }).catch((error) => { 
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
        }).then(() => { 
          localStorage.removeItem("Token");
          localStorage.removeItem("AuthorizeToken");
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
        });
    });
  },
};
</script>

<style>
</style>